module.exports = __webpack_public_path__ + "static/media/brandLogo.d56b7907.png";